import type { ReactNode } from 'react';

import type { CommunityMembershipData } from '../_hooks/useCommunityMembership';
import { useCommunityMembership } from '../_hooks/useCommunityMembership';
import type { CommunityPermissions } from '../_utils/permissions';

type PermissionAwareNode = ReactNode | ((context: CommunityMembershipData) => ReactNode);
type PermissionKey = keyof CommunityPermissions;
type PermissionPredicate = (permissions: CommunityPermissions) => boolean;

interface PermissionGateProps {
  require: PermissionKey | PermissionPredicate;
  children: PermissionAwareNode;
  fallback?: PermissionAwareNode;
}

const resolveRenderable = (node: PermissionAwareNode, context: CommunityMembershipData): ReactNode =>
  typeof node === 'function' ? node(context) : node;

export const PermissionGate = ({ require, children, fallback = null }: PermissionGateProps) => {
  const context = useCommunityMembership();
  const allowed = typeof require === 'function' ? require(context.permissions) : Boolean(context.permissions[require]);

  return resolveRenderable(allowed ? children : fallback, context);
};
